import { Alert } from 'antd';
import React from 'react'
const Notification = (props) => <Alert message={props.message} type={props.messageType} showIcon />;
export default Notification;